const encodeRegex = /[<>&]/g;
const mapping = new Map<string, string>([
  ["<", "&lt;"],
  [">", "&gt;"],
  ["&", "&amp;"],
]);

export function encodeEntities<T>(str: T): T {
  if (typeof str !== "string") {
    return str;
  }
  return str.replace(encodeRegex, (s) => mapping.get(s) || s) as any;
}

export function decodeEntities<T>(str: T): T {
  if (typeof str !== "string") {
    return str;
  }
  const txt = document.createElement("textarea");
  txt.innerHTML = str;
  return txt.value as any;
}
